import { createAction, props } from '@ngrx/store';
import { CompletedKraModel, EmployeeHrNoteModel, EmployeeReviewInfoModel, EmployeeReviewModel, EmployeeReviewOpenPeriod, EmployeeReviewOversightLoadModel, KraReportModel, OverseenEmployeeModel, SecondOversightReviewViewModel } from '../../../models/employeeReviewModels';
import { EmployeeReviewTemplateModel } from '../../../models/employeeReviewTemplateModels';
import { PagingResultsModel } from '../../../models/pagingResultsModel';
import { ModifiedSelectItem } from '../../../models/utilModels';

export const loadMyTemplates = createAction('[Employee Review] Load My Templates');
export const loadMyTemplatesSuccess = createAction('[Employee Review] Load My Templates Success',
  props<{ templates: EmployeeReviewTemplateModel[] }>());

export const postPlayerReview = createAction('[Employee Review] Post Player Review', props<{ review: EmployeeReviewModel }>());
export const postPlayerReviewSuccess = createAction('[Employee Review] Post Player Review Success');
export const postPlayerReviewFailure = createAction('[Employee Review] Post Player Review Failure');

export const postOversightReview = createAction('[Employee Review] Post Oversight Review', props<{ review: EmployeeReviewModel }>());
export const postOversightReviewSuccess = createAction('[Employee Review] Post Oversight Review Success');
export const postOversightReviewFailure = createAction('[Employee Review] Post Oversight Review Failure');

export const autoSaveOversightReview = createAction('[Employee Review] AutoSave Oversight Review', props<{ review: EmployeeReviewModel }>());
export const autoSaveOversightReviewSuccess = createAction('[Employee Review] AutoSave Oversight Review Success');
export const autoSaveOversightReviewFailure = createAction('[Employee Review] AutoSave Oversight Review Failure');

export const getEmployeeReviews = createAction('[Employee Review] Get Employee Reviews', props<{ userId: number }>());
export const getEmployeeReviewsSuccess = createAction('[Employee Review] Get Employee Reviews Success', props < { oversightData: EmployeeReviewOversightLoadModel }>());
export const getEmployeeReviewsFailure = createAction('[Employee Review] Get Employee Reviews Failure');

export const save2ndOversightReview = createAction('[Employee Review] Save 2nd Oversight Review', props<{ secondOversightReview: SecondOversightReviewViewModel }>());
export const save2ndOversightReviewSuccess = createAction('[Employee Review] Save 2nd Oversight Review Success');


export const loadReviews = createAction('[Employee Review] Load Reviews',
  props<{ userId:number, filter: any }>());
export const loadReviewsSuccess = createAction('[Employee Review] Load Reviews Success',
  props<{ employeeReviews: PagingResultsModel<EmployeeReviewInfoModel> }>());


export const getOverseenEmployee = createAction('[Employee Review] Get Overseen Employee', props<{ userId: number }>());
export const getOverseenEmployeeSuccess = createAction('[Employee Review] Get Overseen Employee Success',
  props<{ user: OverseenEmployeeModel }>());

export const getEmployeeReview = createAction('[Employee Review] Get Employee Review', props<{ reviewId: number }>());
export const getEmployeeReviewSuccess = createAction('[Employee Review] Get Employee Review Success',
  props<{ review: EmployeeReviewOversightLoadModel }>());


export const getOversightReview = createAction('[Employee Review] Get Oversight Review', props<{ reviewId: number }>());
export const getOversightReviewSuccess = createAction('[Employee Review] Get Oversight Review Success',
  props<{ review: EmployeeReviewOversightLoadModel }>());


export const autoSavePlayerReview = createAction('[Employee Review] AutoSave Player Review', props<{ review: EmployeeReviewModel }>());
export const autoSavePlayerReviewSuccess = createAction('[Employee Review] AutoSave Player Review Success');
export const autoSavePlayerReviewFailure = createAction('[Employee Review] AutoSave Player Review Failure');

export const getCompletedKraList = createAction('[Employee Review] Get Completed KRA List', props<{ filter: any }>());
export const getCompletedKraListSuccess = createAction('[Employee Review] Get Completed KRA List Success',
  props<{ completedKraList: PagingResultsModel<CompletedKraModel> }>());

export const saveMeetsExpectations = createAction('[Employee Review] Save Meets Expectations', props<{ review: CompletedKraModel }>());
export const saveMeetsExpectationsSuccess = createAction('[Employee Review] Save Meets Expectations Success');

export const getReviewOpenPeriod = createAction('[Employee Review] Get Review Open Period', props<{ userId: number }>());
export const getReviewOpenPeriodSuccess = createAction('[Employee Review] Get Review Open Period Success',
  props<{ openPeriod: EmployeeReviewOpenPeriod }>());

export const getKraList = createAction('[Employee Review] Get KRA List', props<{ filter: any }>());
export const getKraListSuccess = createAction('[Employee Review] Get KRA List Success',
  props<{ kraList: PagingResultsModel<KraReportModel> }>());

export const loadTemplateFilter = createAction('[Employee Review] Load Template Filter');
export const loadTemplateFilterSuccess = createAction('[Employee Review] Load Template Filter Success',
  props<{ templates: ModifiedSelectItem[] }>());

export const unlockEmployeeReview = createAction('[Employee Review] Unlock Employee Review',
  props<{ reviewId: number }>());
export const unlockEmployeeReviewSuccess = createAction('[Employee Review] Unlock Employee Review Success');
export const unlockEmployeeReviewFail = createAction('[Employee Review] Unlock Employee Review Fail',
  props<{ err: any }>());

export const unlockEmployeeReviewOversight = createAction('[Employee Review] Unlock Employee Review Oversight',
  props<{ reviewId: number }>());
export const unlockEmployeeReviewOversightSuccess = createAction('[Employee Review] Unlock Employee Review Oversight Success');
export const unlockEmployeeReviewOversightFail = createAction('[Employee Review] Unlock Employee Review Oversight Fail',
  props<{ err: any }>());

export const deleteEmployeeReview = createAction('[Employee Review] Delete Employee Review',
  props<{ reviewId: number }>());
export const deleteEmployeeReviewSuccess = createAction('[Employee Review] Delete Employee Review Success');
export const deleteEmployeeReviewFail = createAction('[Employee Review] Delete Employee Review Fail',
  props<{ err: any }>());

export const deleteEmployeeReviewOversight = createAction('[Employee Review] Delete Employee Review Oversight',
  props<{ reviewId: number }>());
export const deleteEmployeeReviewOversightSuccess = createAction('[Employee Review] Delete Employee Review Oversight Success');
export const deleteEmployeeReviewOversightFail = createAction('[Employee Review] Delete Employee Review Oversight Fail',
  props<{ err: any }>());

export const awardQuarterlyBonus = createAction('[Employee Review] Award Quarterly Bonus ',
  props<{ oversightReviewId: number }>());
export const awardQuarterlyBonusSuccess = createAction('[Employee Review] Award Quarterly Bonus Success');
export const awardQuarterlyBonusFail = createAction('[Employee Review] Award Quarterly Bonus Fail',
  props<{ err: any }>());

export const recalculateQuarterlyBonus = createAction('[Employee Review] Recalculate Quarterly Bonus ',
  props<{ payrollBonusId: number }>());
export const recalculateQuarterlyBonusSuccess = createAction('[Employee Review] Recalculate Bonus Success');
export const recalculateQuarterlyBonusFail = createAction('[Employee Review] Recalculate Bonus Fail',
  props<{ err: any }>());

export const rejectQuarterlyBonus = createAction('[Employee Review] Reject Quarterly Bonus ',
  props<{ oversightReviewId: number, reason: string }>());
export const rejectQuarterlyBonusSuccess = createAction('[Employee Review] Reject Quarterly Bonus Success');
export const rejectQuarterlyBonusFail = createAction('[Employee Review] Reject Quarterly Bonus Fail',
  props<{ err: any }>());

export const resetQuarterlyBonus = createAction('[Employee Review] Reset Quarterly Bonus ',
  props<{ oversightReviewId: number }>());
export const resetQuarterlyBonusSuccess = createAction('[Employee Review] Reset Quarterly Bonus Success');
export const resetQuarterlyBonusFail = createAction('[Employee Review] Reset Quarterly Bonus Fail',
  props<{ err: any }>());

export const showEditEmployeeNote = createAction('[Employee Review] Show Edit Employee HR Note Modal',
  props < { employeeId: number}>());
export const closeEditEmployeeNote = createAction('[Employee Review] Close Edit Employee HR Note Modal');

export const saveEmployeeNote = createAction('[Employee Review] Save Employee HR Note',
  props<{ hrNote: EmployeeHrNoteModel }>());
export const saveEmployeeNoteSuccess = createAction('[Employee Review] Save Employee HR Note Success');
export const saveEmployeeNoteFail = createAction('[Employee Review] Save Employee HR Note Fail',
  props<{ err: any }>());

export const getEmployeeHrNotes = createAction('[Employee Review] Get Employee HR Notes',
  props<{ employeeId: number }>());
export const getEmployeeHrNotesSuccess = createAction('[Employee Review] Get Employee HR Notes Success',
  props<{ notes: EmployeeHrNoteModel[] }>());
